import { PaymentMethodType, SinglePaymentStatus } from '@nemuru-eng/js-api-client';

import {
  MilestoneProgressStages,
  NonActiveProgressStages,
  SinglePaymentStatusProgressStages,
  SinglePaymentStatusViewStatus,
} from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/Progress/_shared/types';
import { AbstractProgress } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/Progress/AbstractProgress';
import { Milestone } from '@/components/modules/Funnel/types/Milestone';

export abstract class AbstractSinglePaymentProgress extends AbstractProgress {
  private readonly NON_ACTIVE_STATUSES = Object.keys(
    SINGLE_PAYMENT_PROGRESS_NON_ACTIVE_STAGES,
  ) as SinglePaymentStatus[];
  private readonly COMPLETED_STATUSES = [SinglePaymentStatus.CONFIRMED];

  protected _statuses: SinglePaymentStatusViewStatus[] | undefined = undefined;

  constructor(singlePaymentId: string, paymentMethodType: PaymentMethodType) {
    super(singlePaymentId, paymentMethodType, SINGLE_PAYMENT_PROGRESS_STAGES);
  }

  protected getStatusName(status: SinglePaymentStatus) {
    return status;
  }

  protected getNonActiveStages(): NonActiveProgressStages {
    return SINGLE_PAYMENT_PROGRESS_NON_ACTIVE_STAGES;
  }

  protected isNonActiveStatus(status: SinglePaymentStatus): boolean {
    return this.NON_ACTIVE_STATUSES.includes(status);
  }

  protected isCompletedStatus(status: SinglePaymentStatus): boolean {
    return this.COMPLETED_STATUSES.includes(status);
  }

  public get statuses(): SinglePaymentStatusViewStatus[] | undefined {
    return this._statuses;
  }
}

const SINGLE_PAYMENT_PROGRESS_STAGES: Partial<MilestoneProgressStages> = {
  [Milestone.INITIAL]: [
    {
      nameTextId: Milestone.INITIAL,
      status: SinglePaymentStatus.PENDING,
      isMainStep: true,
      checkpointGroup: 1,
    },
  ],
  [Milestone.REQUESTED]: [
    {
      nameTextId: Milestone.REQUESTED,
      status: SinglePaymentStatus.PROCESSING,
      isMainStep: true,
      checkpointGroup: 2,
    },
  ],
  [Milestone.CONFIRMED]: [
    {
      nameTextId: Milestone.CONFIRMED,
      status: SinglePaymentStatus.CONFIRMED,
      isMainStep: true,
      checkpointGroup: 3,
    },
  ],
};

const SINGLE_PAYMENT_PROGRESS_NON_ACTIVE_STAGES: SinglePaymentStatusProgressStages = {
  [SinglePaymentStatus.DENIED]: [
    {
      nameTextId: 'DENIED',
      status: SinglePaymentStatus.DENIED,
      isMainStep: true,
      checkpointGroup: 0,
    },
  ],
  [SinglePaymentStatus.CANCELLED]: [
    {
      nameTextId: 'CANCELLED',
      status: SinglePaymentStatus.CANCELLED,
      isMainStep: true,
      checkpointGroup: 0,
    },
  ],
};
